import type { ILocalityRepository } from "$src/domain/map/ILocalityRepository";
import { Locality } from "$src/domain/map/Locality";
import { ServiceTokens } from "$src/domain/ServiceTokens";
import { inject, injectable } from "tsyringe";

@injectable()
export class GetLocalitiesByPostalCode {
    
    constructor(@inject(ServiceTokens.LocalityRepository) private localityRepository: ILocalityRepository) {}

    async execute(countryCode: string, query: string): Promise<Locality[]> {
        var project = await this.localityRepository.getByPostalCode(countryCode, query);
        return project;
    }
}

export const GetLocalitiesByPostalCodeToken = Symbol('GetLocalitiesByPostalCodeToken');    
